import { render, staticRenderFns } from "./RemoteAttendanceDetailsView.vue?vue&type=template&id=8d456bca&"
import script from "./RemoteAttendanceDetailsView.vue?vue&type=script&lang=js&"
export * from "./RemoteAttendanceDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./RemoteAttendanceDetailsView.vue?vue&type=style&index=0&id=8d456bca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports